import React from "react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  return (
    <div
      className=" twrapper bg-login pace-done  d-flex justify-content-center align-items-center min-vh-100 bg-light"
      style={{
        backgroundImage: "url('/images/logistic.jpg')",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        minWidth: "100vw",
      }}
    >
      <div
        className="text-center p-4 p-md-5  rounded-4 shadow-sm thank-you-box"
        style={{
          backgroundColor: "rgb(239 239 239 / 89%)",
          border: "1px solid rgba(222, 207, 207, 0.2)",
          backdropFilter: "blur(10px)",
          color: "rgb(0 0 0)",
        }}
      >
        <div className="mb-4">
          <div className="icon-circle bg-light mx-auto">
            <i className="bx bx-envelope bx-lg text-danger"></i>
          </div>
        </div>
        <h2 className="fw-bold mb-2 thank-title">
          Thank you for submitting your registration.
        </h2>
        <p className="text-muted mb-4">
          {" "}
          Our team will review your application and get back to you via email as
          soon as possible..
        </p>
        <Link to="/" className="btn btn-danger rounded-pill px-4 py-2">
          <i className="bx bx-arrow-back me-2"></i>Login
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
